export default __webpack_public_path__ + "static/media/moviesDetailsBottom.67196df0.jpeg";